import { RefObject } from "react";
import { AgGridReact } from "ag-grid-react";
import { useDetailTableHandlers as useCommonDetailTableHandlers } from "src/hooks/useDetailTableHandlers";
import { useCodeSearch } from "src/hooks/useCodeSearch";
import { createModuleConfig } from "src/utils/detail-table/detailTableUtils";
import { calculateDetailAmount } from "src/utils/calculation/calculationUtils";
import { WMS2091_R01DetailDto } from "../Dto_WMS2091_R01";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
interface UseWMS2091_R01CellChangeProps {
	WMS2091_R01DetailList: WMS2091_R01DetailDto[];
	originalWMS2091_R01DetailList: WMS2091_R01DetailDto[];
	updateWMS2091_R01DetailList: (index: number, data: WMS2091_R01DetailDto) => void;
	gridRef: RefObject<AgGridReact<WMS2091_R01DetailDto> | null>;
	setCodeSearchModalProps: any;
	customCd?: string;
}

export function useWMS2091_R01CellChange({
	WMS2091_R01DetailList,
	originalWMS2091_R01DetailList,
	updateWMS2091_R01DetailList,
	gridRef,
	setCodeSearchModalProps,
	customCd,
}: UseWMS2091_R01CellChangeProps) {
	const { searchExactItemCode } = useCodeSearch({});
	const WMS2091R01Config = createModuleConfig.WMS1130();

		 // PROGRAM 공통코드에서 ITEM_POPUP_SEARCH의 ref01 값으로 필터 사용 여부 결정
		 const { programList } = useCommonCodeStore();
		 const useCustomCdFilter =
			 programList.find(c => c.minorCd === 'ITEM_POPUP_SEARCH')?.ref01 === 'Y';

	const fieldConfigWithSearch = {
		...WMS2091R01Config.fieldConfig,
		codeSearchFields: {
			...WMS2091R01Config.fieldConfig.codeSearchFields,
			itemCd: {
				...WMS2091R01Config.fieldConfig.codeSearchFields!.itemCd,
				searchFilters: () =>
					useCustomCdFilter && customCd?.trim() ? { customCd: customCd.trim() } : undefined,
				searchFunction: searchExactItemCode,
				canOpenModal: (row: WMS2091_R01DetailDto) => !!row?.inserted,
			},
		},
	};

	const WMS2091_FIELD_MAPPING = {
		qtyField: "qty",
		priceField: "cost",
		dcField: "dcAmt",
		amountField: "amt",
		preventNegative: true,
	};

	const calculateAmount = (data: WMS2091_R01DetailDto): WMS2091_R01DetailDto => {
		return calculateDetailAmount(data, WMS2091_FIELD_MAPPING);
	};

	return useCommonDetailTableHandlers<WMS2091_R01DetailDto>({
		detailList: WMS2091_R01DetailList,
		updateDetailList: updateWMS2091_R01DetailList,
		originalDetailList: originalWMS2091_R01DetailList,
		setCodeSearchModalProps,
		gridRef,
		fieldConfig: fieldConfigWithSearch,
		codeSearchConfig: WMS2091R01Config.codeSearchConfig,
		calculateAmount,
	});
}
